import { render, staticRenderFns } from "./FloatLoginAndApplyTips.vue?vue&type=template&id=37718419&scoped=true"
import script from "./FloatLoginAndApplyTips.vue?vue&type=script&lang=js"
export * from "./FloatLoginAndApplyTips.vue?vue&type=script&lang=js"
import style0 from "./FloatLoginAndApplyTips.vue?vue&type=style&index=0&id=37718419&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37718419",
  null
  
)

export default component.exports